import React, { useId } from "react";

// Campos del panel que no cubre <Input /> (select, textarea, switch).
// Usan las mismas clases que Input para verse igual.

export const Campo = ({ label, error, ayuda, children }) => (
  <div className="input-container-wrapper">
    <div className="input-wrapper">
      {label && <label className="poppins-regular-font">{label}</label>}
      {children}
    </div>
    {ayuda && !error && <p className="pp-ayuda">{ayuda}</p>}
    {error ? <p className="input-error-text">{error}</p> : null}
  </div>
);

export const Select = ({ label, value, onChange, opciones, error, ayuda, disabled }) => (
  <Campo label={label} error={error} ayuda={ayuda}>
    <select
      className={`poppins-regular-font pp-select ${error ? "input-error" : ""}`}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    >
      {opciones.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </Campo>
);

export const TextArea = ({ label, value, onChange, onBlur, error, ayuda, placeholder, rows = 3, maxLength = 300 }) => (
  <Campo label={label} error={error} ayuda={ayuda}>
    <textarea
      className={`poppins-regular-font pp-textarea ${error ? "input-error" : ""}`}
      value={value}
      rows={rows}
      maxLength={maxLength}
      placeholder={placeholder}
      onBlur={onBlur}
      onChange={(e) => onChange(e.target.value)}
    />
  </Campo>
);

export const Switch = ({ label, checked, onChange, disabled, compacto }) => {
  const id = useId();
  return (
    <label htmlFor={id} className={`pp-switch ${compacto ? "pp-switch-compacto" : ""} ${disabled ? "disabled" : ""}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="pp-switch-pista" aria-hidden="true" />
      {label && <span className="pp-switch-label">{label}</span>}
    </label>
  );
};

export const IconButton = ({ icon, title, onClick, variante = "", disabled }) => (
  <button
    type="button"
    className={`pp-icon-btn ${variante}`}
    title={title}
    aria-label={title}
    onClick={onClick}
    disabled={disabled}
  >
    <i className={`bi ${icon}`} />
  </button>
);
